import { useCallback, useMemo, useState } from "react";
import moment from "moment";

import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { useEpic, useEpicThroughId } from "../../../../../reactQuery/epics";
import { useResponsive } from "../../../../../hooks/useResponsive";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";
import { getResponseData } from "../../../../../reactQuery/response";

export function useMilestoneSectionState() {
  const [editMilestone, setEditMilestone] = useState(false);
  const [openMergeMilestone, setOpenMergeMilestone] = useState(false);
  const [milestone] = useCustomSearchParams("milestone");
  const { id } = useBoardIdByKey();
  const { epics: milestonesQuery } = useEpic(id);
  const { epics: selectedMilestoneQuery } = useEpicThroughId(milestone);
  const isMobile = useResponsive("down", "md");

  const allMilestones = useMemo(
    () =>
      getResponseData(milestonesQuery, []).filter(
        (item) => item.is_locked === false
      ),
    [milestonesQuery]
  );
  const selectedMilestoneData = useMemo(
    () => getResponseData(selectedMilestoneQuery, {}),
    [selectedMilestoneQuery]
  );
  const milestoneSummary = useMemo(
    () => ({
      allocatedHours: selectedMilestoneData?.total_allocated_hours,
      hoursSpent: selectedMilestoneData?.total_hours_spent,
      exceedHours: selectedMilestoneData?.total_exceeded_hours,
      remainingHours: selectedMilestoneData?.total_remaining_hours,
      targetDate: selectedMilestoneData?.epic?.target_release_date
        ? moment(selectedMilestoneData.epic.target_release_date).format("MM/DD/YYYY")
        : "NA",
    }),
    [selectedMilestoneData]
  );

  const handleMilestoneClick = useCallback((event) => {
    if (event.target.closest(".gant-chart-switch")) {
      return;
    }

    setEditMilestone(true);
  }, []);

  return {
    allMilestones,
    editMilestone,
    handleMilestoneClick,
    isMobile,
    milestoneSummary,
    openMergeMilestone,
    selectedMilestoneData,
    setEditMilestone,
    setOpenMergeMilestone,
  };
}
